import type { ShippingMethod } from '../types';

export type ParcelSize = 'A' | 'B' | 'C';

export const PARCEL_SIZES: ParcelSize[] = ['A', 'B', 'C'];

/**
 * Picks an InPost gabaryt from how many shirts go in the box.
 *
 * Mirrored from apps/api/src/util/parcelSize.ts, which is what the buyer is actually charged;
 * this copy exists so checkout can price a cart without a round-trip, and so the kiosk can
 * preselect a size. parcelPricing.test.ts asserts the two stay in step.
 */
export function parcelSizeForShirtCount(shirtCount: number): ParcelSize {
  if (shirtCount >= 10) return 'C';
  if (shirtCount >= 5) return 'B';
  return 'A';
}

type ShippingPrices = {
  paczkomat_cost_a_grosze: number;
  paczkomat_cost_b_grosze: number;
  paczkomat_cost_c_grosze: number;
  kurier_cost_a_grosze: number;
  kurier_cost_b_grosze: number;
  kurier_cost_c_grosze: number;
};

export function shippingCostGrosze(
  prices: ShippingPrices,
  method: ShippingMethod,
  size: ParcelSize,
): number {
  if (method === 'odbior' || method === 'zagranica') return 0;
  if (method === 'paczkomat') {
    return size === 'C'
      ? prices.paczkomat_cost_c_grosze
      : size === 'B'
        ? prices.paczkomat_cost_b_grosze
        : prices.paczkomat_cost_a_grosze;
  }
  return size === 'C'
    ? prices.kurier_cost_c_grosze
    : size === 'B'
      ? prices.kurier_cost_b_grosze
      : prices.kurier_cost_a_grosze;
}
